import React, {PropTypes} from 'react';
import Link from '../../routing/components/Link';
import {articleIndexRoute} from '../../../constants/public-routes';
import {getIdFromRelation} from '../../app/selectors';
import {FormattedMessage} from 'react-intl';

class ArticleCompare extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.fetchIfNeeded = this.fetchIfNeeded.bind(this);
  }

  componentDidMount() {
    this.fetchIfNeeded(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.fetchIfNeeded(nextProps);
  }

  fetchIfNeeded(props) {
    let {articleCompareId, articleCompare, fetchArticleCompare} = props;
    if (articleCompareId && !articleCompare.isFetching) {
      if (!articleCompare.item.id || articleCompare.item.id !== articleCompareId) {
        fetchArticleCompare(articleCompareId);
      }
    }
  }

  render() {
    let {articleCompare, lang} = this.props;

    if (!articleCompare.item.attributes) {
      return (<div>Loading..</div>);
    }

    let list = [articleCompare.item.attributes.content];

    let elements = [];
    while (list.length > 0) {
      let element = list.shift();
      if (element) {
        elements.push(element);
        list = element.children.concat(list);
      }
    }

    return (
      <div>
        <div>
          {elements.map(element =>
            <div key={element.id} style={{marginBottom: 16}} dangerouslySetInnerHTML={{__html: element.body}}/>
          )}
        </div>
        <div>
          <Link
            url={articleIndexRoute(lang, getIdFromRelation(articleCompare.item, 'structure'), articleCompare.item.id)}><FormattedMessage
            id="read"/>&nbsp;<FormattedMessage id="article"/></Link>
        </div>
      </div>
    );
  }
}

ArticleCompare.propTypes = {
  articleCompareId: PropTypes.string,
  articleCompare: PropTypes.object.isRequired,
  fetchArticleCompare: PropTypes.func.isRequired,
  lang: PropTypes.string.isRequired
};

export default ArticleCompare;



/** WEBPACK FOOTER **
 ** ./src/modules/articles/components/ArticleCompare.js
 **/